import { IApplicationState } from '../../types/redux';
import { getIsAgent } from '../user';

export const getIsNextStepAvailable = (state: IApplicationState): boolean => {
  const isAgent = getIsAgent(state);
  const textIsValid = Boolean(state.newAnswer.data.answer.value);
  const userStatusIsValid = isAgent ? true : Boolean(state.newAnswer.data.userStatus.value);

  return textIsValid && userStatusIsValid;
};
